import axios from 'axios';
import { APIURL }  from './index'; 

export const LOGIN = 'LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_ISLOADING = 'LOGIN_ISLOADING';  

export function fetch_login(loginUrl) {

  const url = `${APIURL}/login`;

  return (dispatch) => {
    const request = axios.post(url, loginUrl, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    dispatch(login_isloading(true))
    request.then((response) =>{
      dispatch(login_error(false))
      return response; 
    })
    .then((response)=>{
      dispatch(login_success(response))
      dispatch(login_isloading(false))
    })
    .catch((err) => {
      dispatch(login_isloading(false))
      return dispatch(login_error(err.response))
    });
  }
}

export function login_isloading(bool){
  return {
    type: LOGIN_ISLOADING,
    isLoading: bool
  }
}

export function login_success(response){
  return {
      type:LOGIN,
      payload: response
    }
}

export function login_error(bool){
  return {
    type:LOGIN_ERROR,
    hasErrored: bool
  }
}


// WEBPACK FOOTER //
// ./src/actions/fetch_login.js